import { ApiResponse, Dict, PaginatedApiResponse } from "../..";
import {  ListSort } from "../models";

import { LeadRequirement } from "../models/requirement";
import * as http from "./http";
import ApiService from "./service";

export class TenancyService extends ApiService {

  public async getTenancyHistoryExpiredList(
    data: {
      page?: number;
      search?: string;
      perPage?: number;
    } & ListSort &
      Dict
  ) {
    const url = `${this.apiDomain}/api/tenant-history/expired`;
    const response = await http.post<PaginatedApiResponse<any>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }

  public async getTenantsByDate(
    data: {
      tenancyLeaseFromExpiryDate?: Date;
      tenancyLeaseToExpiryDate?: Date;
      projectID?: any;
    } 
  ) {
    const url = `${this.apiDomain}/api/tenant-history/project`;
    const response = await http.post<ApiResponse<any>>(
      url,
      data,
      this.store
    );

    return response?.data?.data;
  }
}
